var bloomingville = bloomingville || {};

( function () {
    'use strict';
    bloomingville.init = function () {
        bloomingville.activeCampaign.init();
        bloomingville.hotspotsProductApp.init();
        bloomingville.carousel.init();
        bloomingville.megamenu.init();
        bloomingville.dealersearch.init();
        bloomingville.toggleHideShowContent.init();
        bloomingville.salesteam.init();
        bloomingville.customSelect.init();
        bloomingville.customInput.init();
        bloomingville.myOrders.init();
        bloomingville.order.init();
        bloomingville.OrderTypeToggle.init();
        bloomingville.languageModal.init();
        bloomingville.productlistCarousel.init();
        bloomingville.carouselMod.init();
        bloomingville.iPaper.init();
        bloomingville.colliInCart.init();
        bloomingville.checkboxFormRequireFields.init();
        bloomingville.clerkIO.init();
        bloomingville.regexReplace.init();
        bloomingville.bulkCopy.init();
    };
    
    bloomingville.activeCampaign      = {
        init: function () {
            if (jQuery('.js-bloomingville-activecampaign').length > 0) {
                bloomingville.activeCampaign.customCheckbox();
                bloomingville.activeCampaign.styling();
                bloomingville.activeCampaign.errorMsg.init();
            }
        },
        customCheckbox: function () {
            var jActiveCampaignObj = jQuery('.js-bloomingville-activecampaign');
            jActiveCampaignObj.find('._checkbox-radio').addClass('custom-checkbox');
            jActiveCampaignObj.find('._checkbox-radio > input').addClass('custom-control-input').after('<span class="custom-control-indicator"></span>');
        },
        styling: function () {
            jQuery('.js-bloomingville-activecampaign style').remove();
            var jFooterForm = jQuery('.e-footer').find('.js-bloomingville-activecampaign');
            jFooterForm.find('label').css({
                'color': '#d9d9d9'
            });
            jQuery('.js-bloomingville-activecampaign').find('._button-wrapper ._submit').removeClass('_submit').addClass('btn btn-primary');
        },
        errorMsg: {
            removeClasses: function () {
                jQuery("._error-inner._no_arrow").hide()
            },
            onSubmit: function () {
                jQuery('._form').on('submit', function () {
                    bloomingville.gdpr.init();
                    if (!jQuery(this).find('input[type=checkbox]').is(':checked')) {
                        bloomingville.activeCampaign.errorMsg.removeClasses();
                    }
                });
            },
            onChange: function () {
                jQuery('._form').on('change', 'input[type=checkbox]', function () {
                    bloomingville.gdpr.init();
                    if (jQuery(this).is(':checked')) {
                        bloomingville.activeCampaign.customCheckbox();
                    } else {
                        bloomingville.activeCampaign.errorMsg.removeClasses();
                    }
                });
            },
            init: function () {
                bloomingville.activeCampaign.errorMsg.onSubmit();
                bloomingville.activeCampaign.errorMsg.onChange();
            }
        }
    };
    bloomingville.checkboxFormRequireFields = {
        init: function () {
            jQuery('.js-checkbox-require-inputs-container').find('input').removeClass('required');
            jQuery( '.js-checkbox-require-inputs' ).on( "click", function(event) {
                if(jQuery( event.target ).is(':checked')) {
                    jQuery('.js-checkbox-require-inputs-container').find('input').addClass('required');
                } else {
                    jQuery('.js-checkbox-require-inputs-container').find('input').removeClass('required');
                }
            });
        }
    };
    bloomingville.clerkIO = {
        init: function(){
            if(jQuery('.js-clerk-content').length > 0){
                bloomingville.clerkIO.bindEvents()
            }
        },
        bindEvents: function () {
            jQuery('.js-clerk-content').on('click', 'a', function ( event ) {
                event.preventDefault();
                var strHref = jQuery(event.target).closest('a').attr('href');
                var jElement = jQuery(event.target).closest('.js-e-productlist-item').parent();
                var jParentElement = jQuery(event.target).closest('.js-clerk-content').find('.e-productlist').find('.row').first();
                var intIndex = jParentElement.find(jElement).index();
                bloomingville.clerkIO.post(intIndex, strHref)
            });
        },
        post: function ( intIndex, strUrl ) {
            jQuery('#js-post-form').remove();
            jQuery('body').append('<form id="js-post-form" action="'+strUrl+'" method="post" style="display: none;"><input name="clerkRecommendation" value="true"/><input name="clerkIndex" value="'+intIndex+'"/></form>');
            jQuery('#js-post-form').submit();
        }
    };
    bloomingville.colliInCart = {
        init: function () {
            bloomingville.colliInCart.bindEvents()
        },
        bindEvents: function () {
            jQuery('.js-e-canvas, .js-e-search').on('change', '.js-input-colli-change', function (event) {

                var colliInCartFormContainer = jQuery(event.target).closest('.js-bloomingville-colli-in-cart');
                var availableProductsToPutInCart = colliInCartFormContainer.attr('data-stock') - colliInCartFormContainer.attr('data-products-in-cart');
                var numberAboveOrBelowToCalculateMax = availableProductsToPutInCart % colliInCartFormContainer.attr('data-colli');
                var inputMaxValue = availableProductsToPutInCart - numberAboveOrBelowToCalculateMax;
                var inputNumber = jQuery(event.target).closest('form').find('input[type="number"]');

                console.log(inputNumber.val(), availableProductsToPutInCart, numberAboveOrBelowToCalculateMax, inputMaxValue)

                inputNumber.attr({
                    'max': inputMaxValue
                });
                if (inputNumber.val() >= inputMaxValue) {
                    jQuery(event.target).closest('form').find('.js-bloomingville-colli-info-text').removeClass('d-none')
                } else {
                    jQuery(event.target).closest('form').find('.js-bloomingville-colli-info-text').addClass('d-none')
                }
            })
        }
    };
    bloomingville.productlistCarousel = {
        init: function () {
            var jCarousel = jQuery('#bloomingville-productlist-carousel').find('.productlist-carousel-inner');
            if (jCarousel.length > 0) {
                jCarousel.find('.productlist-carousel-item').first().addClass('active');




            }
            $('#bloomingville-productlist-carousel').on('slide.bs.carousel', function (e) {

                var $e = $(e.relatedTarget);
                var idx = $e.index();
                var itemsPerSlide = 5;
                var totalItems = $('.productlist-carousel-item').length;

                if (idx >= totalItems-(itemsPerSlide-1)) {
                    var it = itemsPerSlide - (totalItems - idx);
                    for (var i=0; i<it; i++) {
                        // append slides to end
                        if (e.direction=='left') {
                            $('.productlist-carousel-item').eq(i).appendTo('.productlist-carousel-inner');
                        }
                        else {
                            $('.productlist-carousel-item').eq(0).appendTo('.productlist-carousel-inner');
                        }
                    }
                }
            });
        }
    };

    bloomingville.carouselMod = {
        init: function () {
            var jCarousel = jQuery('.js-e-product-images');
            if (jCarousel.length > 0) {
                jCarousel.on('slide.bs.carousel', '#js-e-product-image-carousel',function (event) {
                    jQuery(event.target).css('pointer-events', 'none');
                }).on('slid.bs.carousel', '#js-e-product-image-carousel',function (event) {
                    jQuery(event.target).css('pointer-events', 'all');
                });
            }
        }
    };

    bloomingville.languageModal = {
        init: function(){
            //if(jQuery('#js-boomingville-language-modal').length > 0){
            //    jQuery('#js-boomingville-language-modal').modal('show');
            //    bloomingville.languageModal.bindEvents();
            //}
        },
        bindEvents: function(){
            jQuery('#js-boomingville-language-modal').on('click', '.js-btn-lang', function ( event ) {
                setTimeout(function(){
                    jQuery('#js-boomingville-language-modal').find('form').submit();
                }, 250);
            });

            jQuery('#js-boomingville-language-modal').on('hidden.bs.modal', function ( event ) {
                var data = jQuery('#js-boomingville-language-modal').find('form').serialize();
                bloomingville.languageModal.post(data);
            });
        },
        post: function ( data ) {
            jQuery.ajax({
                url: '',
                data: data,
                method: 'POST'
            });
        }
    };

    bloomingville.OrderTypeToggle = {
        init: function () {
            if(jQuery('.js-custom-form-ordertype-toggle').length > 0){
                bloomingville.OrderTypeToggle.bindEvents();
                if(jQuery('.js-e-checkout').length){
                    jQuery('.js-e-checkout').find('#BloomingvilleIsUserFair').val(jQuery('.js-custom-form-ordertype-toggle').find('#bloomingvilleIsUserFair').val());
                }
            }
        },
        bindEvents: function () {
            jQuery('.js-custom-form-ordertype-toggle').on('click', 'a', function ( event ) {
                jQuery('.js-custom-form-ordertype-toggle').find('a').removeClass('text-primary bg-dark disabled').addClass('text-dark');
                jQuery(event.target).removeClass('text-dark').addClass('text-primary bg-dark disabled');
                var jForm = jQuery(event.target).closest('form');
                jForm.find('#bloomingvilleIsUserFair').val(jQuery(event.target).data('value'));
                jForm.submit();
            });
            
            jQuery('.js-section-impersonation-toggle-btn').on('click', function ( event ) {
                var jElement = jQuery(event.currentTarget);
                var jSectionImpersonation = jElement.closest('.js-section-impersonation');
                var isSectionCollapsed = jSectionImpersonation.hasClass('section-collapsed');  //js-section-impersonation section-collapsed
                if(isSectionCollapsed){
                    jSectionImpersonation.removeClass('section-collapsed');
                } else {
                    jSectionImpersonation.addClass('section-collapsed');
                }
            });
            

            jQuery('.js-e-checkout').on('click', '.js-remote-ordertype-toggle a', function ( event ) {
                var value = jQuery(event.target).data('value');
                jQuery('.js-remote-ordertype-toggle').find('a').removeClass('text-primary bg-dark disabled').addClass('text-dark');
                jQuery(event.target).removeClass('text-dark').addClass('text-primary bg-dark disabled');
                jQuery('.js-custom-form-ordertype-toggle').find('a[data-value="'+value+'"]').trigger('click');
            });
        }
    };

    bloomingville.myOrders = {
        init: function(){
            if(jQuery('.js-bloomingville-myorders-container').length > 0){
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-bloomingville-myorders' );
                    var objProductData = {};
                    bloomingville.myOrders.build( objProductData );
                    bloomingville.customSelect.bindEvents();
                    bloomingville.myOrders.bindEvents();
                });
            }
        },
        bindEvents: function(){
            jQuery('.js-bloomingville-orders-form').on('change', function( event ){
                bloomingville.myOrders.build(jQuery( event.target ).closest('form').serialize());
            });
            jQuery('.js-bloomingville-myorders').on('click', '.js-order-doc', function(event){
                event.preventDefault();
                var jElement = jQuery(event.target);
                bloomingville.myOrders.pdf.get('docType='+jElement.data('doctype')+'&docno='+jElement.data('docno'));
            });
        },
        build: function(objOrdersData){
            bloomingville.myOrders.ajax( {
                method: 'GET',
                data: objOrdersData
            }, function ( data ) {
                jQuery('.js-bloomingville-myorders').find('.js-orders-count').text(data.orderCount);
                jQuery('.js-bloomingville-myorders-container').html( e4.handlebars.tmpl.bloomingvilleMyorders( data ) );
                jQuery( '.js-bloomingville-myorders' ).find('.js-e-loading-overlay').removeClass( 'is-loading' );
            } );
        },
        pdfWindow: null,
        pdf: {
            get: function(objData){
                console.log('0', objData);
                bloomingville.myOrders.pdf.ajax( {
                    method: 'GET',
                    data: objData
                }, function ( response ) {

                    if(response === 'fejl' ||response === 'no_result'){
                        alert('Sorry - Can´t get the order.');
                    } else {
                        location.href = e4.settings.ecom.myorders.pdf.url + '?' + objData;
                    }
                } );
            },
            ajax: function( objAjaxSettings, fnCallback ){
                var jqXHR = jQuery.ajax( jQuery.extend( {
                    url: e4.settings.ecom.myorders.pdf.url,
                    method: 'GET',
                    dataType : 'text',
                    cache: false,
                    beforeSend: function () {
                        bloomingville.myOrders.pdfWindow = window;
                    }
                }, objAjaxSettings ) );
                jqXHR.done( function ( data ) {
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( data );
                    }
                } );
            }
        },
        ajax: function ( objAjaxSettings, fnCallback ) {
            var jqXHR = jQuery.ajax( jQuery.extend( {
                url: e4.settings.ecom.myorders.url,
                method: 'POST',
                dataType: 'json',
                cache: false,
                beforeSend: function () {
                    jQuery( '.js-bloomingville-myorders' ).find('.js-e-loading-overlay').addClass( 'is-loading' );
                }
            }, objAjaxSettings ) );
            jqXHR.done( function ( data ) {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( data );
                }
            } );
        }
    };

    
    bloomingville.bulkCopy = {
        init: function () {
            if ( jQuery('.js-btn-copy-items').length > 0 ) {
                bloomingville.bulkCopy.bindEvents();
            }
        },
        bindEvents: function () {
            jQuery('.js-btn-copy-items').on('click', function(event){
                event.preventDefault();
                var jElementBtn = jQuery(event.currentTarget);
                bloomingville.bulkCopy.fetch(jElementBtn);
            });
        },
        fetch: function( jElementBtn ) {
            jElementBtn.tooltip();
            var parentSelector = jElementBtn.data('parent-selector'); //.js-bloomingville-order-table
            var itemSelector = jElementBtn.data('item-selector'); //.js-orderline-item-number
            var promptMessage = jElementBtn.data('prompt-message');
            var successMessage = jElementBtn.data('success-message');
            var copiedValuesString = jQuery(parentSelector).find(itemSelector).map(function(i,e){return jQuery(e).text()}).toArray().join('\n');

            if (navigator.clipboard === undefined) {
                prompt(promptMessage, copiedValuesString);
            } else {
                navigator.clipboard.writeText(copiedValuesString).then(function(){
                    //success
                    alert(successMessage);
                },function(){
                    //failure, fallback to prompt
                    bloomingville.order.actionPrompt(promptMessage, copiedValuesString);
                });
            }
        }
    }
    
    
    bloomingville.order = {
        init: function(){
            if (jQuery('.js-bloomingville-order-detail-container').length > 0) {
                bloomingville.order.bindEvents();
                jQuery('.js-order-copy-item-numbers').tooltip();
            }
        },
        bindEvents: function(){
            var copyLink = jQuery('.js-order-copy-item-numbers');
            jQuery('.js-bloomingville-order-detail-container').on('click', '.js-order-copy-item-numbers', function(){
                var itemNumbersString = jQuery('.js-orderline-item-number').map(function(i,e){return jQuery(e).text()}).toArray().join('\n');
                if (navigator.clipboard === undefined) {
                    bloomingville.order.actionPrompt(copyLink.data('prompt-message'), itemNumbersString);
                } else {
                    navigator.clipboard.writeText(itemNumbersString).then(function(){
                        //success
                        alert(copyLink.data('success-message'));
                    },function(){
                        //failure, fallback to prompt
                        bloomingville.order.actionPrompt(copyLink.data('prompt-message'), itemNumbersString);
                    });
                }
            }).on('click', '.js-bloomingville-reorder-btn', function ( event ) {
                event.preventDefault();
                bloomingville.order.addMultiToCart();
            });
        },
        actionPrompt: function(promptMessage, itemNumbersString){
            prompt(promptMessage, itemNumbersString)
        },
        postToCart: function(jsonData){
            var postData = {};
            postData['CartCmd'] = 'addmulti';
            if(jsonData.products.length > 0){
                jQuery.each(jsonData.products, function(intIndex, objProduct){
                    postData['ProductLoopCounter'+intIndex] = intIndex;
                    postData['ProductID'+intIndex] = objProduct.id;
                    postData['VariantID'+intIndex] = objProduct.variantId;
                    postData['UnitID'+intIndex] = '';
                    postData['Quantity'+intIndex] = objProduct.colliQuantity;
                });
                e4.cart.addProduct(postData);
            } else {
                alert('Beklager - Produkterne ikke længere tilgængelig');
            }
            
        },
        getProductIds: function(){
            var arrProductIds = [];
            jQuery('.js-bloomingville-order-table').find('.js-orderline-item-number').each(function(intIndex, domElement){
                arrProductIds.push(jQuery(domElement).text());
            });
            return arrProductIds.join(',');
        },
        addMultiToCart: function(data){
            bloomingville.iPaper.addmultiData = {};
            var objProductDataSettings = {
                ProductIds: bloomingville.order.getProductIds()
            };

            jQuery.ajax( {
                method: 'GET',
                url: e4.settings.ecom.productlist.url,
                dataType: 'json',
                data: objProductDataSettings,
                beforeSend: function () {

                },
            } ).done( function ( jsonData ) {
                bloomingville.order.postToCart(jsonData);
            } );
        }
    };

    bloomingville.toggleHideShowContent = {
        init: function () {
            bloomingville.toggleHideShowContent.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-e-product-images' ).on( 'loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function () {
                jQuery( '#js-nav-item-toggle-more-images' ).click( function () {
                    jQuery( '.js-hide-elements-until-toggle' ).removeClass( "hide" );
                    jQuery( '.nav-item-details-more-images' ).addClass( "hide" ).removeClass("d-lg-block");
                } );
            } );
        }
    };
    bloomingville.megamenu = {
        init: function () {
            bloomingville.megamenu.bindEvents();
        },
        bindEvents: function () {
            var navItem = jQuery('li.e-dropdown-mega');
            navItem.on('mouseenter', function(event){
                jQuery('.e-megamenu-container').removeClass('show');
                jQuery(event.target).parent().find('.e-megamenu-container').addClass('show')
            });
            navItem.on('mouseleave', function(event){
                jQuery('.e-megamenu-container').removeClass('show');
                jQuery(event.target).parent().find('.e-megamenu-container').removeClass('show')
            });

            jQuery('.dropdown').on('click.bs.dropdown.data-api', function (event) {

                if (jQuery(event.currentTarget).is('li.dropdown.e-dropdown-mega.nav-item.has-children')) {
                    if (jQuery(window).width() > 1349) {
                        event.preventDefault();
                        event.stopPropagation();
                        location.href = jQuery(event.target).closest('a').attr('href');
                    }
                }
            });

            // var navItem = jQuery( '.js-nav-link-image-value' );
            //
            // jQuery( '.dropdown-toggle.nav-link' ).on( 'click', function ( event ) {
            //     var navCollapse = jQuery( event.currentTarget ).parent().find( '.dropdown-menu' ),
            //         navItemImage = navCollapse.find( '.js-nav-link-image-value' ).first().data( 'image' );
            //     navCollapse.find( '.js-e-megamenu-image' ).css( "background-image", "url(/admin/public/getimage.ashx?Crop=0&Image=" + navItemImage + "&Format=jpg&Width=960&Height=720&Quality=70)" );
            // } );
            //
            // jQuery( navItem ).each( function () {
            //     jQuery( this ).hover( function () {
            //         jQuery( '.js-e-megamenu-image' ).css( "background-image", "url(/admin/public/getimage.ashx?Crop=0&Image=" + jQuery( this ).data( 'image' ) + "&Format=jpg&Width=960&Height=720&Quality=70)" );
            //     } );
            // } );

        }
    };
    bloomingville.carousel = {
        init: function () {
            bloomingville.carousel.bindEvents();
        },
        bindEvents: function () {
            jQuery( "div[id*='carousel-brand']" ).find( '.carousel-indicators li' ).hover( function () {
                var goto = Number( jQuery( this ).attr( 'data-slide-to' ) );
                jQuery( "div[id*='carousel-brand']" ).carousel( goto );
            } );
        }
    };

    bloomingville.constants = {
        animationIterationDelay: 3500
    };

    bloomingville.utils = {
        animations: {
            'animation': 'animationend',
            'OAnimation': 'oAnimationEnd',
            'MozAnimation': 'animationend',
            'WebkitAnimation': 'webkitAnimationEnd'
        },
        getAnimationsEvent: function () {
            var elem = document.createElement( 'fakeelement' );
            for ( var i in bloomingville.utils.animations ) {
                if ( elem.style[ i ] !== undefined ) {
                    return bloomingville.utils.animations[ i ];
                }
            }
        }
    };

    bloomingville.hotspotsProductApp = {
        init: function () {
            bloomingville.hotspotsProductApp.bindEvents();
        },
        bindEvents: function () {

            jQuery( '.js-hotspots-product-app-item-content' ).on( 'mouseleave', function ( event ) {
                jQuery( event.currentTarget ).removeClass( 'show' );
            } );
            jQuery( '.js-hotspots-product-app-image' ).each( function ( intIndex, domImage ) {
                jQuery( domImage ).on( 'click', function ( event ) {
                    jQuery( event.target ).parent().find( '.js-hotspots-product-app-item-content' ).removeClass( 'show' );
                } );
            } );
            jQuery( '.js-hotspot-animate-delay' ).each( function ( intIndex, containerElm ) {
                bloomingville.hotspotsProductApp.bindAnimations( containerElm );

                jQuery( containerElm ).find( '.js-hotspots-product-app-item' ).each( function ( intIndex, domElm ) {
                    jQuery( domElm ).on( 'mouseover', function ( event ) {
                        jQuery( containerElm ).find( '.js-hotspots-product-app-item-content' ).removeClass( 'show' );
                        jQuery( containerElm ).find( '.js-hotspots-product-app-item-content[data-ref="' + event.target.id + '"]' ).addClass( 'show' );
                    } );
                } );
            } );
        },
        bindAnimations: function ( domElm ) {
            var animationEvent = bloomingville.utils.getAnimationsEvent(),
                jAppItems = jQuery( domElm ).find( '.js-hotspots-product-app-item' );

            jAppItems.last().one( animationEvent,
                function () {
                    jQuery( domElm ).removeClass( 'is-animating' );
                    setTimeout( function () {
                        jQuery( domElm ).addClass( 'is-animating' );
                        bloomingville.hotspotsProductApp.bindAnimations( domElm );
                    }, bloomingville.constants.animationIterationDelay );
                } );
        }
    };
    bloomingville.dealersearch = {
        options: {
            url: jQuery( 'html' ).data( 'area' ) + '/system/data/dealersearch-online',
            lang: jQuery( 'html' ).attr( 'lang' )
        },
        loaded: false,
        init: function () {
            if ( jQuery( '#js-e-dealersearch-container' ).length === 1 ) {
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dealersearch-online-heading #js-e-handlebars-tmpl-dealersearch-online-results' );
                    bloomingville.dealersearch.helpers();
                    bloomingville.dealersearch.bindEvents();
                    bloomingville.dealersearch.get();
                } );
            }

        },
        bindEvents: function () {

            var dealersearchContainer = jQuery( '#js-e-dealersearch-container' );

            dealersearchContainer.on( 'change', '.js-bloomingville-country-selector', function (event) {

                var country = jQuery(event.target).val();
                var options = jQuery('.js-e-dealersearch-country').nextAll('ul.options');
                var activeOption = jQuery('.js-e-dealersearch-country').val();
                if (activeOption !== country) {
                    options.find('li[rel="' + country + '"]').trigger('click');
                }

                var searchInputValue = jQuery( '.js-bloomingville-dealersearch-online-users-search-input' ).val();
                bloomingville.dealersearch.get( { search: searchInputValue, countryCode: jQuery( this ).val() } );
            } );

            dealersearchContainer.on( 'input', '.js-bloomingville-dealersearch-online-users-search-input', e4.util.debounce( function ( event ) {
                var countrySelected = jQuery( '.js-bloomingville-country-selector' ).val();
                bloomingville.dealersearch.get( { search: event.target.value, countryCode: countrySelected } )
            }, e4.settings.debounceDelay.input ) );
        },
        helpers: function () {

            Handlebars.registerHelper( 'dealersByCountry', function ( country, dealers, options ) {

                var dealerKeys = Object.keys( dealers ),
                    result = '';

                dealerKeys.forEach( function ( key ) {
                    if (jQuery('.js-toggle-headings-based-on-login').length === 1 && key !== 'Partenaire' && key !== 'Partner') {
                        result += '';
                    } else if (key === 'Partenaire' || key ==='Partner') {
                        result += '<h2 data-loyalty="Partner" class="order-first col-12 border-bottom col-12 my-2 mx-1 pb-1 px-0 js-bloomingville-dealersearch-heading-hide-if-empty">' + key + '</h2>';
                    } else {
                        result += '<h2 class="col-12 border-bottom col-12 my-2 mx-1 pb-1 px-0 js-bloomingville-dealersearch-heading-hide-if-empty">' + key + '</h2>';
                    }

                    dealers[key].filter(function (dealer) {
                        if (dealer.country.countryCode === country && dealer.distributor.value === true) {
                            result += options.fn(dealer);
                        }
                    });
                } );
                return result;
            } );
            Handlebars.registerHelper( 'isDistributor', function ( country, dealers, options ) {
                var dealerKeys = Object.keys( dealers );

                dealerKeys.forEach( function ( keyIndex ) {
                    dealers[ keyIndex ].forEach(
                        function ( dealerObject ) {
                            if ( dealerObject.country.countryCode === country ) {
                                if ( dealerObject.distributor.value === true ) {
                                    return options.fn( this );
                                }
                            }
                        }
                    )
                } );
                return options.inverse( this );
            } );
        },
        get: function ( querySearch ) {
            querySearch = querySearch || {};
            jQuery.ajax( {
                url: bloomingville.dealersearch.options.url,
                type: 'GET',
                dataType: 'json',
                data: querySearch,
            } )
                .done( function ( data ) {
                    bloomingville.dealersearch.build( data, querySearch );
                } )
                .fail( function ( error ) {
                    console.error( error );
                } );
        },
        build: function ( data, querySearch ) {
            if ( jQuery.isEmptyObject( querySearch ) ) {
                var jHeaderContainer = jQuery( '#js-e-dealersearch-online-heading' );
                jHeaderContainer.html( e4.handlebars.tmpl.dealersearchOnlineHeading( data ) );
                var defaultCountry = jQuery( '#js-e-dealersearch-container' ).data( 'defaultCountry' );
                bloomingville.dealersearch.get( { countryCode: defaultCountry } );
            }
            bloomingville.dealersearch.buildResults( data );
        },
        buildResults: function ( data ) {
            var jResultsContainer = jQuery( '#js-e-dealersearch-online-results' );
            jResultsContainer.html( e4.handlebars.tmpl.dealersearchOnlineResults( data ) );
            jResultsContainer.find( '.js-bloomingville-dealersearch-heading-hide-if-empty' ).each( function ( index, domElm ) {
                if ( jQuery( domElm ).next().is( '.js-bloomingville-dealer' ) === false ) {
                    jQuery( domElm ).hide();
                }
            } );
            if (bloomingville.dealersearch.loaded === false) {
                bloomingville.customSelect.bindEvents();
                bloomingville.dealersearch.loaded = true;
            }
        }
    };
    bloomingville.salesteam = {
        options: {
            url: jQuery( 'html' ).data( 'area' ) + '/system/data/sales-team',
            lang: jQuery( 'html' ).attr( 'lang' )
        },
        notChangedYet: true,
        init: function () {
            if ( jQuery( '#js-e-salesteam-container' ).length === 1 ) {
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-salesteam' );
                    bloomingville.salesteam.bindEvents();
                    bloomingville.salesteam.get();
                } );
            }
        },
        bindEvents: function () {
            jQuery( '#js-e-salesteam-container' ).on( 'change', '.js-bloomingville-salesteam-selector', function () {

                if (jQuery( '.js-bloomingville-salesteam-selector[data-selector="country"]' ).val() === "") {
                    jQuery('.js-show-if-all-is-chosen').removeClass('d-none');
                    jQuery('.js-hide-if-all-is-chosen').addClass('d-none');
                } else {
                    jQuery('.js-show-if-all-is-chosen').addClass('d-none');
                    jQuery('.js-hide-if-all-is-chosen').removeClass('d-none');
                }

                jQuery( '.js-bloomingville-salesteam' ).hide();

                var bloomingvilleSelectorCountry = jQuery( '.js-bloomingville-salesteam-selector[data-selector="country"]' ).val() === '' ? '' : '[data-country-code*="' + jQuery( '.js-bloomingville-salesteam-selector[data-selector="country"]' ).val() + '"]';
                var bloomingvilleHasValues         = jQuery( '.js-bloomingville-salesteam' + bloomingvilleSelectorCountry);

                bloomingvilleHasValues.fadeIn( 'slow' );

                if ( bloomingvilleHasValues.length === 0 ) {
                    jQuery( '.bloomingville-no-results' ).removeClass( 'd-none' );
                }
                else {
                    jQuery( '.bloomingville-no-results' ).addClass( 'd-none' );
                }
                jQuery( '.bloomingville-intro-text' ).addClass( 'd-none' );

            } );
        },
        get: function () {
            jQuery.ajax( {
                url: bloomingville.salesteam.options.url,
                type: 'GET',
                data: {
                    groupname: jQuery('.js-find-salesteam-group-name').val()
                },
                dataType: 'json',
            } )
                .done( function ( data ) {
                    bloomingville.salesteam.build( data );
                } )
                .fail( function ( error ) {
                    console.error( error );
                } );
        },
        build: function ( data ) {
            var jContainer = jQuery( '#js-e-salesteam-container' );
            jContainer.html( e4.handlebars.tmpl.salesteam( data ) );
            bloomingville.customSelect.bindEvents();
            jContainer.find( '.js-bloomingville-salesteam-selector').trigger('change');
        }
    };
    bloomingville.customInput = {
        init: function () {
            bloomingville.customInput.bindEvents();
            jQuery('.js-e-cart').on('updated.e4.cart', function (event) {
                bloomingville.customInput.bindEvents();
            });
            jQuery('.js-e-productlist').on('builded.e4.productlist', function (event) {
                bloomingville.customInput.bindEvents();
            }).on('inserted.e4.productlist', function () {
                bloomingville.customInput.bindEvents();
            });
            jQuery('.js-bloomingville-ipaper-addmulti').on('builded.e4.ipaper', function(event){
                bloomingville.customInput.bindEvents();
            });
        },
        bindEvents: function() {
            (function( jQuery ) {

                jQuery.fn.numberstyle = function(options) {

                    /*
                     * Default settings
                     */
                    var settings = jQuery.extend({
                        value: 0,
                        step: undefined,
                        min: undefined,
                        max: undefined
                    }, options );

                    /*
                     * Init every element
                     */
                    return this.each(function(i) {

                        /*
                         * Base options
                         */
                        var input = jQuery(this);
                        if(input.is('.input-has-function') === false) {

                            input.addClass('input-has-function');

                            /*
                             * Add new DOM
                             */
                            var container = document.createElement('div'),
                                btnAdd = document.createElement('div'),
                                btnRem = document.createElement('div'),
                                min = (settings.min) ? settings.min : input.attr('min'),
                                max = (settings.max) ? settings.max : input.attr('max'),
                                value = (settings.value) ? settings.value : parseFloat(input.val());
                            container.className = 'numberstyle-qty';
                            btnAdd.className = (max && value >= max ) ? 'qty-btn qty-add disabled' : 'qty-btn qty-add';
                            btnAdd.innerHTML = '+';
                            btnRem.className = (min && value <= min) ? 'qty-btn qty-rem disabled' : 'qty-btn qty-rem';
                            btnRem.innerHTML = '-';
                            input.wrap(container);
                            input.closest('.numberstyle-qty').prepend(btnRem).append(btnAdd);

                            /*
                             * Attach events
                             */
                            // use .off() to prevent triggering twice
                            jQuery(document).off('click','.qty-btn').on('click','.qty-btn',function(e){

                                var input = jQuery(this).siblings('input'),
                                    sibBtn = jQuery(this).siblings('.qty-btn'),
                                    step = (settings.step) ? parseFloat(settings.step) : parseFloat(input.attr('step')),
                                    min = (settings.min) ? settings.min : ( input.attr('min') ) ? input.attr('min') : undefined,
                                    max = (settings.max) ? settings.max : ( input.attr('max') ) ? input.attr('max') : undefined,
                                    oldValue = parseFloat(input.val()),
                                    newVal;

                                //Add value
                                if ( jQuery(this).hasClass('qty-add') ) {

                                    newVal = (oldValue >= max) ? oldValue : oldValue + step,
                                        newVal = (newVal > max) ? max : newVal;

                                    if (newVal === max) {
                                        jQuery(this).addClass('disabled');
                                    }
                                    sibBtn.removeClass('disabled');

                                    //Remove value
                                } else {

                                    newVal = (oldValue <= min) ? oldValue : oldValue - step,
                                        newVal = (newVal < min) ? min : newVal;

                                    if (newVal === min) {
                                        jQuery(this).addClass('disabled');
                                    }
                                    sibBtn.removeClass('disabled');

                                }

                                //Update value
                                input.val(newVal).trigger('change');

                            });

                            input.on('change',function(){

                                const val = parseFloat(input.val()),
                                    min = (settings.min) ? settings.min : ( input.attr('min') ) ? input.attr('min') : undefined,
                                    max = (settings.max) ? settings.max : ( input.attr('max') ) ? input.attr('max') : undefined;

                                if ( val > max ) {
                                    input.val(max);
                                }

                                if ( val < min ) {
                                    input.val(min);
                                }
                                if (jQuery('.js-e-cart').length === 1) {
                                    e4.cart.orderline.update(input.get(0))
                                }
                            });

                        }


                    });
                };

                jQuery('.numberstyle').numberstyle();

            }( jQuery ));
        }
    };

    bloomingville.customSelect = {
        init: function () {
            jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function ( event ) {
                bloomingville.customSelect.bindEvents();
            });
            jQuery('.e-form-dw').find( 'select.custom-select' ).each( function ( ) {
                bloomingville.customSelect.bindEvents();
            });
        },
        bindEvents: function() {

            // Iterate over each select element
            jQuery('select').each(function () {
                // Cache the number of options
                var jQuerythis = jQuery(this),
                    numberOfOptions = jQuery(this).children('option').length;

                // Hides the select element
                jQuerythis.addClass('s-hidden');

                // Wrap the select element in a div
                jQuerythis.wrap('<div class="select"></div>');

                // Insert a styled div to sit over the top of the hidden select element
                jQuerythis.after('<div class="styledSelect"></div>');

                // Cache the styled div
                var jQuerystyledSelect = jQuerythis.next('div.styledSelect');

                var selecetedOption = "";

                jQuerythis.find("option:selected" ).each(function() {
                    selecetedOption += jQuery( this ).val();
                });

                // Show the first select option in the styled div
                jQuerystyledSelect.text(jQuerythis.children('option[value="' + selecetedOption + '"]').text());


                // Insert an unordered list after the styled div and also cache the list
                var jQuerylist = jQuery('<ul />', {
                    'class': 'options'
                }).insertAfter(jQuerystyledSelect);

                // Insert a list item into the unordered list for each select option
                for (var i = 0; i < numberOfOptions; i++) {
                    jQuery('<li />', {
                        text: jQuerythis.children('option').eq(i).text(),
                        rel: jQuerythis.children('option').eq(i).val()
                    }).appendTo(jQuerylist);
                }

                // Cache the list items
                var jQuerylistItems = jQuerylist.children('li');

                // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
                jQuerystyledSelect.click(function (e) {
                    e.stopPropagation();
                    jQuery('div.styledSelect.active').each(function () {
                        jQuery(this).removeClass('active').next('ul.options').hide();
                    });
                    jQuery(this).toggleClass('active').next('ul.options').toggle();
                });

                // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
                // Updates the select element to have the value of the equivalent option

                jQuerylistItems.click(function (e) {
                    e.stopPropagation();
                    jQuerystyledSelect.text(jQuery(this).text()).removeClass('active');
                    jQuerythis.val(jQuery(this).attr('rel'));
                    jQuerylist.hide();
                    /* alert(jQuerythis.val()); Uncomment this for demonstration! */
                    console.log(jQuerythis);
                    jQuerythis.trigger('change');
                });

                // Hides the unordered list when clicking outside of it
                jQuery(document).click(function () {
                    jQuerystyledSelect.removeClass('active');
                    jQuerylist.hide();
                });

            });
        }
    };

    bloomingville.regexReplace = {
        init: function () {
            bloomingville.regexReplace.bindEvents()
        }, bindEvents: function () {
            jQuery('p, h1, h2, h3, h4, h5, h6, table, a, li').each(function (index, domelement) {
                var html = jQuery(domelement).html();
                var replaceHtml = bloomingville.regexReplace.convert(html);

                jQuery(domelement).html(replaceHtml);
            });

        }, convert: function ( html ) {
            var returnValue = html;
            if (html.indexOf("svg") === -1 && (html.indexOf('©') > -1 || html.indexOf('®') > -1)) {
                /*returnValue = html.replace(/[®©]/g, '<sup>$&</sup>');*/
                returnValue = html.replace(/[®©]/g, '<sup>®</sup>');
            }
            return returnValue;
        }
    }
}() );
